import React from 'react';
import styled from '../../styled';

const SpeakerStyles = styled.div`
  background: #D9DCE5;
  border: 3px solid #000000;
  border-radius: 6px;
  outline: none;
  height: 100%;
  width: 100%;

  svg {
    height: 100%;
    width: 100%;
  }
`;

const Speaker: React.FC<any> = () => {
  return (
    <SpeakerStyles>
      <svg viewBox="0 0 175 173" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect rx="6" fill="#D9DCE5" />
        <circle cx="57.8893" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="106.138" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="116.044" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="125.95" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="135.856" r="2.88926" fill="black" />
        <circle cx="57.8893" cy="145.762" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="106.138" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="116.044" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="125.95" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="135.856" r="2.88926" fill="black" />
        <circle cx="67.8893" cy="145.762" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="106.138" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="116.044" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="125.95" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="135.856" r="2.88926" fill="black" />
        <circle cx="77.8893" cy="145.762" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="106.138" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="116.044" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="125.95" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="135.856" r="2.88926" fill="black" />
        <circle cx="87.8893" cy="145.762" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="106.138" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="116.044" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="125.95" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="135.856" r="2.88926" fill="black" />
        <circle cx="97.8893" cy="145.762" r="2.88926" fill="black" />
        <circle cx="107.889" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="107.889" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="107.889" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="107.889" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="107.889" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="107.889" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="107.889" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="107.889" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="107.889" cy="106.138" r="2.88926" fill="black" />
        <circle cx="107.889" cy="116.044" r="2.88926" fill="black" />
        <circle cx="107.889" cy="125.95" r="2.88926" fill="black" />
        <circle cx="107.889" cy="135.856" r="2.88926" fill="black" />
        <circle cx="107.889" cy="145.762" r="2.88926" fill="black" />
        <circle cx="117.889" cy="26.8893" r="2.88926" fill="black" />
        <circle cx="117.889" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="117.889" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="117.889" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="117.889" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="117.889" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="117.889" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="117.889" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="117.889" cy="106.138" r="2.88926" fill="black" />
        <circle cx="117.889" cy="116.044" r="2.88926" fill="black" />
        <circle cx="117.889" cy="125.95" r="2.88926" fill="black" />
        <circle cx="117.889" cy="135.856" r="2.88926" fill="black" />
        <circle cx="117.889" cy="145.762" r="2.88926" fill="black" />
        <circle cx="127.889" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="127.889" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="127.889" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="127.889" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="127.889" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="127.889" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="127.889" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="127.889" cy="106.138" r="2.88926" fill="black" />
        <circle cx="127.889" cy="116.044" r="2.88926" fill="black" />
        <circle cx="127.889" cy="125.95" r="2.88926" fill="black" />
        <circle cx="127.889" cy="135.856" r="2.88926" fill="black" />
        <circle cx="137.889" cy="36.7953" r="2.88926" fill="black" />
        <circle cx="137.889" cy="46.7013" r="2.88926" fill="black" />
        <circle cx="137.889" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="137.889" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="137.889" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="137.889" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="137.889" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="137.889" cy="106.138" r="2.88926" fill="black" />
        <circle cx="137.889" cy="116.044" r="2.88926" fill="black" />
        <circle cx="137.889" cy="125.95" r="2.88926" fill="black" />
        <circle cx="137.889" cy="135.856" r="2.88926" fill="black" />
        <circle cx="147.889" cy="56.6074" r="2.88926" fill="black" />
        <circle cx="147.889" cy="66.5134" r="2.88926" fill="black" />
        <circle cx="147.889" cy="76.4195" r="2.88926" fill="black" />
        <circle cx="147.889" cy="86.3255" r="2.88926" fill="black" />
        <circle cx="147.889" cy="96.2315" r="2.88926" fill="black" />
        <circle cx="147.889" cy="106.138" r="2.88926" fill="black" />
        <circle cx="147.889" cy="116.044" r="2.88926" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 36.7953)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 46.7013)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 56.6074)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 66.5134)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 76.4195)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 86.3255)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 96.2315)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 106.138)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 116.044)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 125.95)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 48.1107 135.856)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 36.7953)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 46.7013)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 56.6074)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 66.5134)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 76.4195)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 86.3255)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 96.2315)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 106.138)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 116.044)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 125.95)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 38.1107 135.856)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 56.6074)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 66.5134)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 76.4195)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 86.3255)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 96.2315)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 106.138)" fill="black" />
        <circle r="2.88926" transform="matrix(-1 0 0 1 27.8892 116.044)" fill="black" />
      </svg>
    </SpeakerStyles>
  );
}

export { Speaker };
